module.exports = __webpack_public_path__ + "img/refresh-disable.047df041.svg";